<template>
<div>

<Trems></Trems>
</div>
</template>

<script>
import Trems from "../../components/Applicant/Trems.vue";



export default {

  components: {
 Trems
  },
  created() {

  }
};
</script>

<style scoped>


                       
</style>